import { inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IconName } from '@fortawesome/fontawesome-svg-core';

export enum ModalType {
    DANGER = 'danger',
    ERROR = 'error',
    INFO = 'info',
    QUESTION = 'question',
    SUCCESS = 'success',
    WARNING = 'warning',
}

export type AbstractModalData = {
    description?: string;
    title?: string;
    type?: ModalType;
};

export abstract class AbstractModalComponent {
    public data: AbstractModalData = inject(MAT_DIALOG_DATA);
    public iconName: IconName = 'circle-question';

    protected constructor() {
        if (!this.data.type) {
            return;
        }

        this.iconName = this.getIconName(this.data.type);
    }

    protected getIconName(type: ModalType): IconName {
        switch (type) {
            case ModalType.ERROR:
                return 'triangle-exclamation';

            case ModalType.INFO:
                return 'circle-info';

            case ModalType.QUESTION:
                return 'circle-question';

            case ModalType.SUCCESS:
                return 'circle-check';

            case ModalType.DANGER:
            case ModalType.WARNING:
                return 'circle-exclamation';
        }
    }
}
